import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import GPSFixed from '@material-ui/icons/GpsFixed'

const styles = theme => ({
  root: {
    minWidth: 28,
    minHeight: 28,
    display: 'flex',
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform .2s ease',
    backgroundColor: theme.palette.white,
    boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: theme.palette.background.light,
    },
  },
  icon: {
    fontSize: 18,
    color: theme.palette.tertiary.main,
  },
})

const LocationButton = ({ classes, ...other }) => (
  <div className={classes.root} {...other}>
    <GPSFixed className={classes.icon} />
  </div>
)

LocationButton.defaultProps = {
  color: 'tertiary',
}

LocationButton.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.object,
}

export default withStyles(styles)(LocationButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/LocationButton.js